import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';

import { MyApp } from './app.component';
import * as page from '../pages/pages';
import * as api from '../api/ecom/ecomApi';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { File } from '@ionic-native/file';
import { FileOpener } from '@ionic-native/file-opener';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { YoutubeProvider } from '../providers/youtube';
import { YoutubeVideoPlayer } from '@ionic-native/youtube-video-player';
import { IonicStorageModule } from '@ionic/storage';
import { Deeplinks } from '@ionic-native/deeplinks';

@NgModule({
	declarations: [
		MyApp,
		page.HomePage,
		page.TopicsPage,
		page.CaseStudiesPage,
		page.CaseStudyPage,
		page.ConferencePage,
		page.VideoPage,
		page.EbookPage,
		page.EbooksPage,
		page.LoginPage,
		page.RegisterPage,
		page.AuthorisedHomePage,
		page.BadgesPage,
		page.BadgePage
	],
	imports: [
		BrowserModule,
		HttpModule,
		IonicModule.forRoot(MyApp),
		IonicStorageModule.forRoot({
			name: '__ECOMAPP',
			driverOrder: ['sqlite', 'websql', 'indexeddb', 'localstorage']
		})
	],
	bootstrap: [IonicApp],
	entryComponents: [
		MyApp,
		page.HomePage,
		page.TopicsPage,
		page.CaseStudiesPage,
		page.CaseStudyPage,
		page.ConferencePage,
		page.VideoPage,
		page.EbookPage,
		page.EbooksPage,
		page.LoginPage,
		page.RegisterPage,
		page.AuthorisedHomePage,
		page.BadgesPage,
		page.BadgePage
	],
	providers: [
		StatusBar,
		SplashScreen,
		FileOpener,
		File,
		InAppBrowser,
		YoutubeProvider,
		YoutubeVideoPlayer,
		api.ecomUserApi,
		Deeplinks,
		{ provide: ErrorHandler, useClass: IonicErrorHandler }
	]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts